module.exports = __webpack_public_path__ + "img/left.6a78544f.svg";